import { render, staticRenderFns } from "./testMechWheel.vue?vue&type=template&id=3031f503&scoped=true"
import script from "./testMechWheel.vue?vue&type=script&lang=js"
export * from "./testMechWheel.vue?vue&type=script&lang=js"
import style0 from "./testMechWheel.vue?vue&type=style&index=0&id=3031f503&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3031f503",
  null
  
)

export default component.exports